import { Flex, Icon, IconButton, Select, Text } from '@chakra-ui/react';
import { Table } from '@tanstack/react-table';
import { useTranslation } from 'helpers/languages/translations';
import icons from 'shared/icons';
import { iconTableStyle, tableToolbarStyle } from 'shared/styles';
import GlobalFilter from 'plugins/DITable/filters/GlobalFilter';
import { DEFAULT_COLOR, TColorsHooks } from './useColors';

interface IColorsToolbarProps {
    table: Table<any>;
    isColorsLoading: boolean;
    isRetailersLoading: boolean;
    isUnsetColorsLoading: boolean;
    unsetColorsData: TColorsHooks['unsetColorsData'];
    selectedType: TColorsHooks['selectedType'];
    handleChangeColorType: TColorsHooks['handleChangeColorType'];
    handleOpenModal: TColorsHooks['handleOpenModal'];
    colorTypes: TColorsHooks['colorTypes'];
    setColorToSubmit: TColorsHooks['setColorToSubmit'];
}

const ColorsToolbar = ({
    table,
    isColorsLoading,
    isRetailersLoading,
    isUnsetColorsLoading,
    unsetColorsData,
    selectedType,
    handleChangeColorType,
    handleOpenModal,
    colorTypes,
    setColorToSubmit,
}: IColorsToolbarProps) => {
    const { setGlobalFilter } = table;
    const translate = useTranslation();

    const PlusIcon = icons.plus;
    return (
        <Flex {...tableToolbarStyle}>
            <GlobalFilter globalFilter={table.getState().globalFilter} setGlobalFilter={setGlobalFilter} />
            <Flex alignItems="center">
                <Text fontSize="sm" mr={3} fontWeight="bold" flexShrink={0}>
                    {translate('colors.toolbar.field.type')}
                </Text>
                <Select size="sm" onChange={handleChangeColorType} value={selectedType} bg="white" mr={2}>
                    {colorTypes.map((type) => (
                        <option key={type} value={type}>
                            {translate(`colors.type.${type}`)}
                        </option>
                    ))}
                </Select>
            </Flex>
            <IconButton
                onClick={() => {
                    const colorObj: Record<string, any> = {
                        type: selectedType,
                        color: DEFAULT_COLOR,
                    };

                    if (unsetColorsData && unsetColorsData.colors.length && unsetColorsData.colors[0].object_id) {
                        colorObj.object_id = unsetColorsData.colors[0].object_id;
                    }
                    setColorToSubmit(colorObj);

                    handleOpenModal('add');
                }}
                {...iconTableStyle}
                aria-label="add alias"
                isDisabled={
                    isColorsLoading || isRetailersLoading || isUnsetColorsLoading || !unsetColorsData?.colors?.length
                }
                size="sm"
                icon={<Icon as={PlusIcon} />}
            />
        </Flex>
    );
};

export default ColorsToolbar;
